import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "u-indu-kpi-list"
};
const _hoisted_2 = {
  key: 0,
  class: "data-loading"
};
const _hoisted_3 = {
  key: 1,
  class: "u-kpi-list"
};
const _hoisted_4 = {
  class: "u-indu-kpi-pagination"
};
import { reactive, computed, watch, h, toRefs } from 'vue';
import { VxeButton, VxeButtonGroup } from 'vxe-pc-ui';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'industry-kpi-list',
  props: {
    search: {
      type: String,
      default: ''
    },
    industryId: {
      type: String,
      default: ''
    },
    depIds: {
      type: Array,
      default: () => []
    },
    kpiType: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 50
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 2
    },
    vspace: {
      type: Number,
      default: 24
    },
    hspace: {
      type: Number,
      default: 24
    }
  },
  emits: ['page-change', 'select', 'open'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const ItemButtons = (props, {
      emit
    }) => {
      const {
        data
      } = toRefs(props);
      const handleSelect = () => {
        emit('select', data.value);
      };
      const handleOpen = () => {
        emit('open', data.value);
      };
      return () => h(VxeButtonGroup, {}, [h(VxeButton, {
        status: 'primary',
        onClick: handleSelect
      }, () => '选择'), h(VxeButton, {
        status: 'default',
        onClick: handleOpen
      }, () => '查询')]);
    };
    const props = __props;
    const emit = __emit;
    const {
      runAsync: searchKpiPage,
      loading
    } = fetchApi('kpi.kpi.searchPage');
    const state = reactive({
      rows: [],
      total: 0,
      pc: 0
    });
    const queryParams = reactive({
      kpiType: 0,
      search: '',
      industryId: '',
      depIds: [],
      pi: 1,
      ps: 50
    });
    const rowGutter = computed(() => {
      return [props.hspace || 16, props.vspace || 16];
    });
    const colSpan = computed(() => {
      if (props.columns === 0) {
        return 24;
      }
      return Math.ceil(24 / props.columns);
    });
    const rowCols = computed(() => {
      const result = [];
      const arr = [...state.rows];
      const splitLen = props.columns;
      for (let i = 0; i < arr.length; i += splitLen) {
        const chunk = arr.slice(i, i + splitLen);
        result.push(chunk);
      }
      return result;
    });
    const kpiItemExtra = computed(() => col => {
      // return [ '', '项目支出绩效表', '部门整体支出绩效表' ][type] || '未知类型';
      return col.industry ? `[${col.industry}]` : '';
    });
    const loadKpiData = async () => {
      const {
        error,
        pi = 1,
        ps = 50,
        total = 0,
        rows = [],
        pc = 0
      } = await searchKpiPage({
        ...queryParams
      });
      if (error) return;
      Object.assign(state, {
        total,
        rows,
        pc
      });
      Object.assign(queryParams, {
        pi,
        ps
      });
    };
    const handleSelectItem = item => {
      emit('select', item);
    };
    const handleOpenItem = item => {
      emit('open', item);
    };
    const handlePageChange = ({
      currentPage,
      pageSize
    }) => {
      Object.assign(queryParams, {
        pi: currentPage,
        ps: pageSize
      });
      loadKpiData();
      emit('page-change', currentPage, pageSize);
    };
    watch([() => props.search, () => props.industryId, () => props.depIds, () => props.kpiType, () => props.pageSize, () => props.pageIndex], arr => {
      const [search = '', industryId = '', depIds = [], kpiType = 0, pageSize = 50, pageIndex = 1] = arr;
      Object.assign(queryParams, {
        search,
        industryId,
        depIds,
        kpiType: parseInt(kpiType + '', 10),
        pi: pageIndex,
        ps: pageSize
      });
      loadKpiData();
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      load: () => {
        queryParams.pi = 1;
        loadKpiData();
      },
      refresh: () => {
        loadKpiData();
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_loading = _resolveComponent("vxe-loading");
      const _component_vxe_col = _resolveComponent("vxe-col");
      const _component_vxe_row = _resolveComponent("vxe-row");
      const _component_vxe_pager = _resolveComponent("vxe-pager");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_vxe_loading, {
        modelValue: _unref(loading),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(loading) ? loading.value = $event : null),
        size: "large",
        text: "加载中..."
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), !_unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowCols.value, (row, i) => {
        return _openBlock(), _createBlock(_component_vxe_row, {
          key: `row_${i}`,
          gutter: rowGutter.value,
          wrap: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, j) => {
            return _openBlock(), _createBlock(_component_vxe_col, {
              key: `col_${j}`,
              span: colSpan.value
            }, {
              default: _withCtx(() => [_createVNode(_component_vxe_row, {
                gutter: 16,
                class: "list-item"
              }, {
                default: _withCtx(() => [_createVNode(_component_vxe_col, {
                  fill: "",
                  align: "left"
                }, {
                  default: _withCtx(() => [_renderSlot(_ctx.$slots, "item", {
                    record: col
                  }, () => [_createElementVNode("span", null, _toDisplayString(col.name) + _toDisplayString(kpiItemExtra.value(col)), 1)])]),
                  _: 2
                }, 1024), _createVNode(_component_vxe_col, {
                  width: _ctx.$slots.itemExtra.length * 80
                }, {
                  default: _withCtx(() => [_renderSlot(_ctx.$slots, "itemExtra", {
                    item: col,
                    row: i,
                    col: j
                  }, () => [_createVNode(ItemButtons, {
                    data: col,
                    onOpen: handleOpenItem,
                    onSelect: handleSelectItem
                  }, null, 8, ["data"])])]),
                  _: 2
                }, 1032, ["width"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["span"]);
          }), 128))]),
          _: 2
        }, 1032, ["gutter"]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_vxe_pager, {
        loading: _unref(loading),
        "current-page": queryParams.pi,
        "page-size": queryParams.ps,
        total: state.total,
        align: "center",
        onPageChange: handlePageChange
      }, null, 8, ["loading", "current-page", "page-size", "total"])])]);
    };
  }
};